import axiosInstance from "app/axiosInstance";
import {
  IVatValidationRequest,
  IVatValidationResponse
} from "../types/vatTypes";

// Expected answers of the VAT check. They resolve, so they never reach the
// error interceptor (Sentry) with the VAT number in the request body.
const VAT_VALIDATION_ANSWERS = [200, 400, 503];

class UtilityService {
  static getAddressFromLatLng = async (latitude: number, longitude: number) => {
    return await axiosInstance.get(
      `/utility/reversegeocode?latitude=${latitude}&longitude=${longitude}`
    );
  };

  // `anonymous`: the activation portal has no session; the endpoint is public
  // and the request must not try to get a token.
  static validateVat = async (
    request: IVatValidationRequest,
    signal?: AbortSignal,
    { anonymous = false }: { anonymous?: boolean } = {}
  ) => {
    return await axiosInstance.post<IVatValidationResponse | undefined>(
      "/utility/vat/validate",
      request,
      {
        signal,
        validateStatus: (status) => VAT_VALIDATION_ANSWERS.includes(status),
        ...(anonymous && { headers: { isNotProtected: true } })
      }
    );
  };
}

export default UtilityService;
